import { createSlice } from '@reduxjs/toolkit';
import {
  getNotifications,
  updateNotificationRead,
  deleteNotification,
  updateNotificationLastSeen,
  // setPushNotificationToken,
} from 'redux/services/NotificationService';

export const NotificationSlice = createSlice({
  name: 'notification',
  initialState: {
    notificationCount: 0,
  },
  reducers: {
    setNotificationCount: (state, action) => {
      state.notificationCount = action.payload;
    },
  },
});

export const handleGetNotifications = (payload) => async () => {
  return getNotifications(payload);
};

export const handleUpdateNotificationRead = (payload) => async () => {
  return updateNotificationRead(payload);
};

export const handleUpdateNotificationLastSeen = (payload) => async () => {
  return updateNotificationLastSeen(payload);
};

export const handleDeleteNotification = (payload) => async () => {
  return deleteNotification(payload);
};

export const handleUpdateNotificationCount = (payload) => async (dispatch) => {
  return dispatch(setNotificationCount(payload));
};

// export const handleSetPushNotificationToken = (payload) => async (dispatch) => {
//   return dispatch(setPushNotificationToken(payload));
// };

export const { setNotificationCount } = NotificationSlice.actions;
export default NotificationSlice.reducer;
